import { Modal, message, Select, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { putRequest } from "../../service";
import { countries } from "../../constant/countery";
import { getChangedFields } from "../../utils/getChangedFields";

const AddressEdit = (props) => {
  const { open, onRequestClose, employee } = props;
  const [form, setForm] = useState({
    country: "",
    city: "",
    zipCode: "",
    nationality: "",
    permanent_address: "",
    temporary_address: ""
  });
  const originalFormRef = useRef({});

  useEffect(() => {
    if (employee) {
      const initialData = {
        country: employee.country || "",
        city: employee.city || "",
        zipCode: employee.zipCode || "",
        nationality: employee.nationality || "",
        permanent_address: employee.permanent_address || "",
        temporary_address: employee.temporary_address || ""
      };
      setForm(initialData);
      originalFormRef.current = initialData;
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (value, name) => {
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, form);
      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }
      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  return (
    <Modal
      title="Address Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="flex items-start justify-between bg-white h-[55vh] overflow-auto">
        <div className="bg-form-bg w-full rounded-md px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col gap-1">
              <label htmlFor="country" className="text-md">
                Country <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <Select
                showSearch
                className="w-full"
                placeholder="Select a country"
                optionFilterProp="value"
                onChange={(value) => handleSelectChange(value, "country")}
                value={form.country}
                filterOption={(input, option) =>
                  (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                }
                options={countries.map(country => ({
                  value: country.value,
                  label: country.value
                }))}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="city" className="text-md">
                City <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="city"
                placeholder="City"
                onChange={handleChange}
                value={form.city}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="zipCode" className="text-md">
                Zip/Postal Code
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="zipCode"
                placeholder="Zip/Postal Code"
                onChange={handleChange}
                value={form.zipCode}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="nationality" className="text-md">
                Nationality
              </label>
              <Select
                showSearch
                className="w-full"
                placeholder="Select nationality"
                optionFilterProp="children"
                onChange={(value) => handleSelectChange(value, "nationality")}
                value={form.nationality}
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
                options={countries}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="permanent_address" className="text-md">
                Permanent Address
              </label>
              <textarea
                placeholder="Address"
                rows={3}
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="permanent_address"
                onChange={handleChange}
                value={form.permanent_address}
              ></textarea>
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="temporary_address" className="text-md">
                Temporary Address
              </label>
              <textarea
                placeholder="Temporary Address"
                rows={3}
                className="border px-2 py-1 rounded-md border-secondary outline-hidden text-md bg-white"
                name="temporary_address"
                onChange={handleChange}
                value={form.temporary_address}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update Address
        </Button>
      </div>
    </Modal>
  );
};

export default AddressEdit;
